import { t } from 'i18next';
import { Button } from '@peacecover/component';
import { GOODS_TYPE_META, GOODS_TYPE_ORDER } from '../../constants/goodsTypeItem';

interface GoodsTypeConfirmPopupProps {
  groupedByType: Record<string, string[]>;
  isLoading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const GoodsTypeConfirmPopup = ({
  groupedByType,
  isLoading = false,
  onConfirm,
  onClose
}: GoodsTypeConfirmPopupProps) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1001]">
      <div className="flex flex-col items-center w-[341px] h-fit bg-background-elevated px-[14px] pt-[32px] pb-[16px] rounded-[24px] gap-[16px]">
        <h2 className="text-[17px] font-bold leading-tight text-center whitespace-pre-wrap">
          {t('ReportEventGoodsTypePage.checkGoodsTypes', {
            defaultValue: '굿즈별로 특전이 올바르게\n지정되었는지 확인해주세요'
          })}
        </h2>
        <div className="bg-separator1 h-[1px] w-full" />
        <div className="flex flex-col gap-[8px] w-full max-h-[50vh] overflow-y-auto">
          {GOODS_TYPE_ORDER.filter(
            (type) => groupedByType[type] && groupedByType[type].length > 0
          ).map((type) => (
            <div key={type} className="flex gap-[11px] px-[20px] py-[8px]">
              <img
                src={`/assets/icons/graphic-3d/3D.${GOODS_TYPE_META[type].image}.png`}
                alt={GOODS_TYPE_META[type].title}
                className="w-[17px] h-[17px]"
              />
              <div className="flex flex-col items-start gap-[6px]">
                <p className="text-[14px] font-medium leading-[17px]">
                  {GOODS_TYPE_META[type].title}
                </p>
                <p className="text-[13px] font-medium text-text-primary leading-tight">
                  {groupedByType[type].join(' · ')}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="flex flex-col gap-[8px] w-full">
          <Button
            size="large"
            className="text-[17px] font-semibold"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {t('ReportEventGoodsTypePage.complete', { defaultValue: '완료하기' })}
          </Button>
          <Button
            size="large"
            btnColor="secondary"
            className="text-[17px] font-semibold"
            onClick={onClose}
            disabled={isLoading}
          >
            {t('ReportEventGoodsTypePage.reselect', { defaultValue: '다시 선택하기' })}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GoodsTypeConfirmPopup;
